<script setup>
import { ref, onMounted } from "vue";
import { useAlert } from "dashboard/composables";
import { useAdmin } from "dashboard/composables/useAdmin";
import SettingsLayout from "../SettingsLayout.vue";
import BaseSettingsHeader from "../components/BaseSettingsHeader.vue";
import Button from "dashboard/components-next/button/Button.vue";
import omniraApi from "../../../../api/omniraApi";

const { isAdmin } = useAdmin();
const loading = ref(false);
const entries = ref([]);

const fetchLogs = async () => {
  loading.value = true;
  try {
    const res = await omniraApi.getActivityLogs();
    entries.value = res.data || [];
  } catch (e) {
    useAlert("Failed to load activity logs");
  } finally {
    loading.value = false;
  }
};

onMounted(fetchLogs);

const fmtTime = t => new Date(t).toLocaleString();
</script>

<template>
  <SettingsLayout>
    <BaseSettingsHeader
      title="Platform Activity"
      description="All user actions captured on the platform: logins, knowledge base and rule changes"
      icon="info"
    />
    <div v-if="loading" class="p-8 text-center text-slate-500">Loading...</div>
    <div v-else class="space-y-4 p-6 max-w-3xl">
      <div class="flex justify-end">
        <Button label="Refresh" size="sm" variant="faded" color="slate" :loading="loading" @click="fetchLogs" />
      </div>
      <div class="space-y-2">
        <div
          v-for="entry in entries"
          :key="entry.id"
          class="rounded-lg border border-slate-200 dark:border-slate-700 p-3 text-xs text-slate-600 dark:text-slate-300"
        >
          <div class="flex items-center justify-between gap-2">
            <span class="font-medium text-slate-700 dark:text-slate-200">{{ entry.action }}</span>
            <span>{{ fmtTime(entry.created_at) }}</span>
          </div>
          <p class="mt-1">
            {{ entry.user_name || (entry.user_id ? "user #" + entry.user_id : "system") }} -
            {{ entry.subject_type ? entry.subject_type + " #" + entry.subject_id : "platform" }}
          </p>
        </div>
        <p v-if="entries.length === 0" class="text-xs text-slate-400">No activity yet.</p>
      </div>
    </div>
  </SettingsLayout>
</template>